import { environment } from '../../environments/environment';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DbmanagerService } from '../services/dbmanager.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css']
})
export class ToolbarComponent implements OnInit {
  user = '';
  switchLanguage = '';
  flagsrc = '';
  searchText = $localize`:@@toolbar.search:Szukaj`;
  searchset = false;
  constructor(private router: Router, private dbservice: DbmanagerService) { }

  ngOnInit(): void {
    if (environment.localebuild === 'en') {
      this.switchLanguage = 'Polski';
      this.flagsrc = '/assets/flagpl.png';
    } else {
      this.switchLanguage = 'English';
      this.flagsrc = '/assets/flagen.png';
    }
    this.dbservice.getUsersItems().subscribe(users => {
        this.user =  this.dbservice.users.get(this.dbservice.currentUserID).NAME;
    });
  }

  logout() {
    localStorage.removeItem('gwareuser');
    localStorage.removeItem('gwarepass');
    this.dbservice.logged = false;
    this.router.navigateByUrl('/login');
  }

  switchLang() {
    if (environment.localebuild === 'en') {
      window.location.href = 'https://findmetestpl.web.app/';
    } else {
      window.location.href = 'https://findmetesten.web.app/';
    }
  }

  searchFocusOut(d) {
    if (d.value.length === 0) {
      this.searchText = d.value = $localize`:@@toolbar.search:Szukaj`;
      this.searchset = false;
    } else {
      this.searchset = true;
    }
  }

  searchChanged(d) {
    if (d.value.length > 0) {
      this.searchset = true;
    }
    this.searchText = d.value ;
  }

  searchFocus(d) {
    if ( this.searchset === false) {
      d.value = '';
    }
  }

}

